import { Touch } from '@syncfusion/ej2-base';
import * as cls from '../base/css-constant';
/**
 * kanban touch module
 */
var KanbanTouch = /** @class */ (function () {
    /**
     * Constructor for touch module
     */
    function KanbanTouch(parent) {
        this.parent = parent;
        this.tabHold = false;
    }
    KanbanTouch.prototype.wireTouchEvents = function () {
        this.element = this.parent.element.querySelector('.' + cls.CONTENT_CLASS);
        this.touchObj = new Touch(this.element, { tapHold: this.tapHoldHandler.bind(this) });
    };
    KanbanTouch.prototype.tapHoldHandler = function (e) {
        this.tabHold = true;
    };
    KanbanTouch.prototype.destroy = function () {
        this.touchObj.destroy();
        this.tabHold = false;
        this.element = null;
    };
    return KanbanTouch;
}());
export { KanbanTouch };
